const ProfileIcon  = () => {
  return (
    <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.73339 10.8581C1.83169 10.2455 0.208648 7.64189 0.930001 5.80405C1.83169 3.50676 7.69256 0.75 11.7502 0.75C15.8078 0.75 21.6688 3.50676 22.5705 5.80405C23.2918 7.64189 21.6688 10.2455 20.7671 10.8581M2.73339 10.8581H20.7671M2.73339 10.8581V13.1554M20.7671 10.8581V13.1554M2.73339 13.1554H20.7671M2.73339 13.1554C3.33447 14.6869 5.97935 17.75 11.7502 17.75C17.521 17.75 20.166 14.6869 20.7671 13.1554M11.7502 4.88514C11.4496 4.88514 10.8485 4.70135 10.8485 3.96622C10.8485 3.23108 11.4496 3.0473 11.7502 3.0473C12.0507 3.0473 12.6519 3.23108 12.6519 3.96622C12.6519 4.70135 12.0507 4.88514 11.7502 4.88514ZM11.7502 4.88514V8.56081M11.7502 8.56081C10.8485 8.56081 9.49595 7.9482 9.0451 7.64189M11.7502 8.56081C12.6519 8.56081 13.3732 8.37703 14.4553 7.64189M10.8485 6.26351H12.6519"
        stroke="#17253C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ProfileIcon
